module.exports = __webpack_public_path__ + "img/visa.0af4360f.png";